<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">

<div class="row">
  <div class="col-md-12">
    <nb-card status="basic" [nbSpinner]="loader" nbSpinnerStatus="danger" nbSpinnerSize="giant">
      <nb-card-header>Complete all steps to complete your process !!!</nb-card-header>
      <nb-card-body  style="padding: 2.5%;">
        <div>
          <nb-stepper orientation="horizontal" (click)="checkTabs(stepper.selectedIndex)" #stepper>
            <nb-step [completed]="tabcheck1" label="Verification Type">
              <nb-card class="nbCard_step1" style="padding: 0%;">
                <nb-card-header class="fontmedia">Select Verification Types (सत्यापन प्रकार निवडा)
                  <h6>(<span style="color:red;">Multiple selection allowed(एकाधिक निवडीची परवानगी आहे)</span>)</h6>
                </nb-card-header>
                <nb-card-body class="from">
                  <div *ngIf="(language=='English') || (language == null || language == undefined ) ">
                  <div style="text-align: left; ">
                    <h5>Instructions</h5>
                    <ol>
                      <li style="color: black;"><b>  तुम्हाला ज्या साठी पडताळणी (Verification) साठी अर्ज करायचा आहे तो पर्याय निवडा.</b>
                      </li>
                      <li style="color: black;"><b>  तुम्ही अनेक पर्याय देखील निवडू शकता.</b></li>
                      <li style="color: black;"><b>  एकदा तुम्ही पडताळणी (Verification) चा प्रकार निवडल्यानंतर मार्कशीटची संख्या (प्रमाण) इनपुट करा (जर अर्जदाराने मार्कशीटवर क्लिक केले तरच).</b></li>
                      <li style="color: black;"><b> तुम्ही प्रमाणित (Verification) करायला इच्छित असल्यास (Transcript) वर क्लिक केल्यास) डिग्रीजची संख्या प्रविष्ट (input) करा.</b></li>
                      <li style="color: black;"><b> तुम्हाला पडताळणी (Verification) करण्याच्या डिग्रीचा क्रमांक (प्रमाण) इनपुट करा (अर्जदाराने पदवीवर क्लिक केले तरच).</b></li>
                    </ol>
                  </div>
                  </div>
                <div *ngIf="(language=='Gujarati')">
                  <div style="text-align: left; ">
                    <h5>સૂચનાઓ</h5>
                    <ul>
                      <li style="color: red;"><b> તે ઓપ્શન પસંદ કરો કે જેના માટે તમે વેરિફિકેશન માટે અરજી કરવા માંગો છો.</b>
                      </li>
                      <li style="color: red;"><b> લઘુત્તમ 1 વિકલ્પ સિલેક્ટ કરવો ફરજિયાત છે - માર્કશીટ, ટ્રાન્સક્રિપ્ટ, ડિગ્રી પ્રમાણપત્ર વચ્ચે, એપ્લિકંટઓ
                        બહુવિધ ઓપ્શનઓ પણ સિલેક્ટ કરી શકે છે.</b></li>
                      <li style="color: red;"><b> માર્કશીટનો નંબર ઇનપુટ કરો (ફક્ત જો અરજદાર માર્કશીટ પર ક્લિક કરે)</b></li>
                      <li style="color: red;"><b> ટ્રાન્સક્રિપ્ટની સંખ્યા ઇનપુટ કરો (ફક્ત જો એપ્લિકંટ ટ્રાન્સક્રિપ્ટ પર ક્લિક કરે તો જ)</b></li>
                      <li style="color: red;"><b> ડિગ્રીની સંખ્યા દાખલ કરો (ફક્ત જો એપ્લિકંટ ડિગ્રી પર ક્લિક કરે)</b></li>
                      <li style="color: red;"><b> જો એપ્લિકંટ ફિઝિકલ કોપી મેળવવા માંગે છે, તો તેણે સીલબંધ કોપી પસંદ કરવી જોઈએ અને તેમને જરૂરી
                        ફિઝિકલ કોપી ની સંખ્યા દાખલ કરવી જોઈએ. જો એપ્લિકંટ ને ડીજીટલ કોપી જોઈતી હોય, તો સીલ કરેલ કોપી
                        સિલેક્ટ કરવાની જરૂર નથી.</b></li>

                    </ul>
                  </div>
                </div>
                  <div class="row">
                    <div class="col-xl-9">
                      <div class="row">
                        <div class="col-md-3">
                          <mat-checkbox (change)="selectVerificationType($event,'marksheet')" status="primary"
                            [checked]="verificationTypes?.marksheet">
                            Marksheets
                          </mat-checkbox>
                        </div>
                        <div class="col-md-3" [hidden]="!(marksheetInput)">
                          <label for="marksheetInput">Number(Quantity) of marksheets</label>
                          <input id="marksheetInput" [ngModel]="verificationTypes?.noOfMarksheet"
                            placeholder="Number(Quantity) of marksheet" (input)="documentCount($event,'marksheet')" />
                        </div>
                        <span style="color:red; font-weight :bold;" *ngIf="verificationTypes?.transcript == true">
                          तुम्ही 'ट्रॅन्सक्रिप्ट' निवडल्यास, सर्व वर्षांच्या वार्षिक / सेमेस्टर मार्कशीट अपलोड करणे अनिवार्य आहे . कृपया अपलोड केलेल्या मार्कशीटची संख्या प्रविष्ट (input) करा.
                        </span>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-md-3">
                          <mat-checkbox (change)="selectVerificationType($event,'transcript')" status="primary"
                            [checked]="verificationTypes?.transcript">
                            Transcript
                          </mat-checkbox>
                        </div>
                        <div class="col-md-3" [hidden]="!(transcriptInput)">
                          <label for="transcriptInput">Number(Quantity) of Transcript</label>
                          <input id="transcriptInput" [ngModel]="verificationTypes?.noOfTranscript"
                            placeholder="Number(Quantity) of degree" (input)="documentCount($event,'transcript')" />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-md-3">
                          <mat-checkbox (change)="selectVerificationType($event,'degreeCertificate')" status="primary"
                            [checked]="verificationTypes?.degreeCertificate">
                            Degree Certificate
                          </mat-checkbox>
                        </div>
                        
                        <div class="col-md-3" [hidden]="!(degreeInput)">
                          <!-- <mat-radio-group aria-label="Select an option" [formControl]="degreeTypeCtrl">
                            <mat-radio-button (change)="selectDegreeType($event)" value="Provisional Degree Certificate"> Provisional Degree Certificate </mat-radio-button>
                            <mat-radio-button (change)="selectDegreeType($event)" value="Degree Certificate"> Degree Certificate </mat-radio-button>
                          </mat-radio-group> -->
                          <label for="degreeInput">Number(Quantity) of degree</label>
                          <input id="degreeInput" [ngModel]="verificationTypes?.noOfDegree" placeholder="Number(Quantity) of degree"
                            (input)="documentCount($event,'degreeCertificate')" />
                        </div>
                      </div>
                      <br />
                      <!-- <div class="row">
                        <div class="col-md-3">
                          <mat-checkbox (change)="selectVerificationType($event,'secondYear')" status="primary"
                            [checked]="verificationTypes?.secondYear">
                            Second Year Marksheets
                          </mat-checkbox>
                        </div>
                        <div class="col-md-6">
                          <span style="color:red; font-weight: bold;">(Select this option if your second year marksheet is issued between 1998 and 2003 by your college)</span>
                        </div>
                      </div>
                      <br /> -->
                      <!-- <div class="row">
                        <div class="col-md-3">
                          <mat-checkbox (change)="selectVerificationType($event,'sealedCover')" status="primary"
                            [checked]="verificationTypes?.sealedCover">
                            Sealed Cover
                          </mat-checkbox>
                        </div>
                        <div class="col-md-3" [hidden]="!(sealedCoverInput)">
                          <label for="sealedCoverInput">Number(Quantity) of Copies</label>
                          <input id="sealedCoverInput" [ngModel]="verificationTypes?.noOfCopies"
                            placeholder="Number(Quantity) of Copies" (input)="documentCount($event,'sealedCover')" />
                        </div>
                      </div><br/> -->
                      <div class="row">
                        <div class="col-md-3">Select Service Type:</div>
                        <div class="col-md-9">
                        <mat-form-field style="width:220px !important">
                          <mat-select [ngModel]="serviceType" placeholder="Select Service Type" id="portal" name="portal" (selectionChange)="selectVerificationType($event,$event.value)">
                            <mat-option value="digital"> Emailed </mat-option>
                            <mat-option value="sealedCover"> Courier </mat-option>
                            <mat-option value="pickup"> Pickup </mat-option>
                          </mat-select>
                        </mat-form-field><br>
                        <div class="col-md-9" *ngIf="sealedCoverInput || pickupInput">
                          <label for="sealedCoverInput">Number(Quantity) of Copies</label>
                          <input id="sealedCoverInput" [ngModel]="verificationTypes?.noOfCopies"
                            placeholder="Number(Quantity) of Copies" (input)="documentCount($event,'sealedCover')" />
                        </div>
                        <!-- <div class="col-md-9" *ngIf="pickupInput">
                          <label for="pickupInput">Number(Quantity) of Copies</label>
                          <input id="pickupInput" [ngModel]="verificationTypes?.noOfPickup"
                            placeholder="Number(Quantity) of Copies" (input)="documentCount($event,'pickup')" />
                        </div> -->
                       <!-- <span *ngIf="portal=='digital'" style="color:red"><b>Personally come to university to submit the orignal Transfer certificate<br> and then to collect the Migration Certificate</b></span>
                        <span *ngIf="portal=='sealed'" style="color:red"><b>Get the certificate delivered at home in 3 days time</b></span> -->
                        </div>
                      </div>

                      <span *ngIf="showError == true" style="color : red; font-weight:bold;">{{errorMessage}}</span>
                    </div>
                    <div class="col-xl-3" style="text-align: center;">
                      
                      <p style="font-size: 150%"><b>Need Help?</b></p><br>
                      <img class="videoimg"  src="{{imageUrl}}/api/upload/profile_pic/PLAY.png" data-toggle="modal" width="100px;" height="100px;" data-target="#myModal" data-video-fullscreen=""  (click)="videoPopup(1)">
                      <br/>
                      <a href="{{imageUrl}}/api/images/SU-VerificationManualStudent.pdf" target="_blank"><img src="{{imageUrl}}/api/upload/profile_pic/pdf.png" width="110px;" height="100px;"></a>
                      <br/>
                      <b>कोणत्याही प्रश्नासाठी, कृपया आम्हाला<a style="color:#40dc7e">{{helpEmailId}}</a>वर ईमेल करा किंवा {{helpMobNo}} वर संपर्क साधा</b>
                    </div>
                  </div>
                </nb-card-body>
                <nb-card-footer class="footer-btn">
                  <button (click)="nextStep();" nbButton>next</button>
                </nb-card-footer>
              </nb-card>
            </nb-step>

            <nb-step [completed]="tabcheck2" label="Document Details & Upload Documents">
              <div class="nbCard_step2">
                <div class="fontmedia">
                  <h2>दस्तऐवज तपशील (Details) जोडा आणि दस्तऐवज अपलोड करा</h2>
                </div>
                <div *ngIf="(language=='English') || (language == null || language == undefined ) ">
                <div style="text-align: left; ">
                  <h5>Instructions (सूचना)</h5>
                  <ol>
                    <!-- <li style="color: red;"><b> Normal delivery mode takes 30 days to process the application</b></li> -->
                    <!-- <li style="color: red;"><b> Urgent delivery mode takes 5 days to process the application</b></li> -->
                    <li style="color: black;"><b> ज्यांची महाविद्यालये (Colleges) आणि अभ्यासक्रम (Courses) पुण्यश्लोक अहिल्यादेवी होळकर सोलापूर विद्यापीठाशी संलग्न (Affiliated) आहेत, त्यांचाच डेटा इनपुट करा.</b>
                    </li>
                    <li style="color: black;"><b> कृपया दिलेल्या ड्रॉपडाउन सूचीमधून कॉलेज आणि कोर्सचे नाव निवडा, मॅन्युअली टाइप करू नका.</b></li>
                    <li style="color: black;"><b> (सूचना: शैक्षणिक तपशील (details) जतन (Save) करण्यासाठी सेव्ह बटणावर क्लिक करा)</b>
                    </li>
                    <li style="color: black;"><b>शैक्षणिक तपशील (Details) जतन (Save) करण्यासाठी सेव्ह बटणावर क्लिक करा.</b>
                    </li>
                    <li style="color: black;"><b> शिक्षण तपशील जतन केल्यानंतर दस्तऐवज पर्याय सक्षम अपलोड करा, सर्व कागदपत्रे मूळ (Original) स्वरूपात अपलोड करणे आवश्यक आहे. कृपया पृष्ठ (Pages) दस्तऐवज एक एक करून अपलोड करा. (पृष्ठे (Pages) एका फाईलमध्ये विलीन (Merge) करू नका).</b>
                    </li>
                    <li style="color: black;"><b>दस्तऐवज केवळ jpg/jpeg/png किंवा pdf स्वरूपात अपलोड करा, फाइल आकार 5 MB असावा.</b>
                    </li>
                    <li style="color: black;"><b>जर तुम्ही पडताळणी (Verification) साठी उतारा (ट्रान्सक्रिप्ट्स) किंवा पदवी (डिग्री) निवडली असेल, तर तुम्हाला वर्षभर (Annual) / सेमिस्टरची मार्कशीट अनिवार्य अपलोड करावी लागेल.</b>
                    </li>
                    <li style="color: black;"><b><li style="color: black;"><b>शैक्षणिक तपशील (Details) जतन (Save) करण्यासाठी सेव्ह बटणावर क्लिक करा.</b>
                    </li></b>
                    </li>
                  </ol>
                  <ul>
                    <li style="color:red"><b>तात्पुरत्या पदवी (PDC) साठी  सत्यापन पत्र (Verification letter) तयार केले जाणार नाही किंवा प्रमाणपत्रां PDC वर शिक्का किंवा स्वाक्षरी केलेली नाही. परंतु इतर कागदपत्रांसह नमूद उद्देशासाठी पाठवले जाईल.</b></li>
                      <li style="color:red"><b>कृपया लक्षात घ्या की पुण्यश्लोक अहिल्यादेवी होळकर सोलापूर विद्यापीठ फक्त पुण्यश्लोक अहिल्यादेवी होळकर सोलापूर विद्यापीठाशी संलग्न (Affiliated) असलेल्या महाविद्यालयातील कागदपत्रांची साक्ष/पडताळणी (attest/verify) करू शकते.</b></li>
                        </ul>
                </div>
                </div>
                <div *ngIf="language=='Gujarati' ">
                  <div style="text-align: left; ">
                    <h5>સૂચનાઓ</h5>
                    <ul>
                      <li style="color: red;"><b> સાથે ચિહ્નિત થયેલ ક્ષેત્રો ફરજિયાત છે.</b></li>
                      <li style="color: red;"><b> જે કૉર્સ માત્ર ગુજરાત યુનિવર્સિટી સાથે સંલગ્ન છે જેની તમે વેરિફિકેશન માટે અરજી કરવા માંગો છો તેની શૈક્ષણિક
                        વિગતો ઉમેરો.</b></li>
                      <li style="color: red;"><b> ડ્રોપ-ડાઉનમાંથી કોર્સ પસંદ કરો. જો તમારો કોર્સ સૂચિબદ્ધ નથી, તો પછી સપોર્ટ સ્ટાફનો સંપર્ક કરો.</b>
                      </li>
                      <li style="color: red;"><b> એપ્લિકંટ એ માત્ર સિલેક્ટ કરેલ વેરિફિકેશન નાં ઓપ્શન નાં દસ્તાવેજો અપલોડ કરવાના રહેશે, જો સિલેક્ટએડ
                        વિગતો સિવાય વધારાની માર્કશીટ/ ટ્રાન્સક્રિપ્ટ/ પ્રમાણપત્ર અપલોડ કરવામાં આવશે, તો એપ્લિકેશન નકારવામાં
                        આવશે.</b></li>
                      <li style="color: red;"><b> એક કરતાં વધુ માર્કશીટ / ટ્રાન્સક્રિપ્ટ / ડિગ્રી પ્રમાણપત્ર માટે, એપ્લિકંટ એ વેરિફિકેશન નો પ્રકાર પસંદ કરતી વખતે
                        નંબર દાખલ કરવો આવશ્યક છે.</b></li>
                      <li style="color: red;"><b> ડોક્યુમેન્ટ્સ અપલોડ કરતા પહેલા શૈક્ષણિક વિગતો સેવ કરો.</b></li>
                      <li style="color: red;"><b> એક પછી એક ડોક્યુમેન્ટ્સ ઓ અપલોડ કરો, તે મર્જ ન કરવા જોઈએ અને jpg/jpeg/png અથવા pdf ફોર્મેટમાં જ
                        અપલોડ કરવા જોઈએ, મહત્તમ ફાઇલ કદ 5 MB હોવી જોઈએ..</b></li>
                      <li style="color: red;"><b> બધા ડોક્યુમેન્ટ્સ ઓ મૂળમાં અપલોડ કરવાના રહેશે. જો ફોટોકોપી/ઝેરોક્સ કોપી અપલોડ કરવામાં આવી રહી હોય,
                        તો એટેસ્ટેશન ફરજિયાત છે.</b></li>
                      <li style="color: red;"><b> જો અરજદાર બીજા વર્ષની ચકાસણી પસંદ કરે છે, તો પછી NOC લેટર ડાઉનલોડ કરવાની, ફોર્મ ભરવાની, કૉલેજની સાઈન અને સ્ટેમ્પ
                        લેવાની અને NOC લેટર ટૅબમાં અપલોડ કરવાની જરૂર છે.</b></li>
                        <li style="color: red;"><b> નોંધ: મહેરબાની કરીને નોંધ કરો કે ગુજરાત યુનિવર્સિટી માત્ર ગુજરાત યુનિવર્સિટી સાથે સંલગ્ન કોલેજોના દસ્તાવેજોને પ્રમાણિત/ચકાસણી કરી શકે છે.</b></li>
                    </ul>
                  </div>
                  </div>
                <div class="row">
                  <div class="col-xl-9">
                    <div class="tabset">
                      <div class="tabsets" (click)="Marksheets()" *ngIf="verificationTypes?.marksheet == true">
                        <h6 [ngClass]="{'tabsets1':marksheetss ,'tabsets':!marksheetss}">
                          Marksheets
                        </h6>
                      </div>
                      <div class="tabsets" (click)="Transcripts()" *ngIf="verificationTypes?.transcript == true">
                        <h6 [ngClass]="{'tabsets1':transcriptss ,'tabsets':!transcriptss}">
                          Transcripts
                        </h6>
                      </div>
                      <div class="tabsets" (click)="Degree()" *ngIf="verificationTypes?.degreeCertificate == true">
                        <h6 [ngClass]="{'tabsets1':degree ,'tabsets':!degree}">
                          Degree Certificate
                        </h6>
                      </div>
                      <div class="tabsets" (click)="secondYear()" *ngIf="verificationTypes?.secondYear == true">
                        <h6 [ngClass]="{'tabsets1':secondYearss ,'tabsets':!secondYearss}">
                          Second Year Marksheet
                        </h6>
                      </div>
                      <div class="tabsets" (click)="aadharcard()">
                        <h6 [ngClass]="{'tabsets1':aadharss ,'tabsets':!aadharss}">
                          Aadhar card / Passport Upload
                        </h6>
                      </div>
                    </div>

                    <div *ngIf="aadharss==true">
                      <nb-card>
                        <nb-card-header>
                          Aadhar Card / Passport
                        </nb-card-header>
                        <nb-card-body>
                          <table>
                            <tr>
                              <th>
                                Aadhar card/Passport
                              </th>
                              <td>
                                आधार हा 12 अंकी वैयक्तिक ओळख क्रमांक आहे जो भारत सरकारच्या वतीने युनिक आयडेंटिफिकेशन ऑथॉरिटी
                                ऑफ इंडियाने जारी केला आहे. हा क्रमांक भारतात कुठेही ओळख आणि पत्त्याचा पुरावा म्हणून काम करतो.
                                <br/>
                                <span style="color: red;">फाइल jpg/png/pdf फॉरमॅटमध्ये असू शकते.</span>
                              </td>
                              <td>
                                <p-fileUpload chooseLabel="Upload" *ngIf="aadharDetails?.id == null || aadharDetails?.lock_transcript == true"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id=aadharDetails?.id&type=Aadhar Card&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event, 'marksheet')" (onSelect)="onSelect($event)"> 
                                </p-fileUpload>
                                <br/>
                                <div *ngIf="aadharDetails?.id != null || aadharDetails?.lock_transcript == false">
                                  <nb-actions style="display: inline;" size="medium" fullWidth
                                    *ngIf="aadharDetails?.id != null || aadharDetails?.lock_transcript == false">
                                    <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                      class="ion ion-ios-eye" title="View File"
                                      (click)="imagePopup(aadharDetails?.file_name,'aadhar_card'); ">
                                    </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                      class="ion ion-ios-trash" title="Delete File"
                                      (click)="deleteDocument(aadharDetails?.id,'aadhar_card')">
                                    </nb-action>
                                  </nb-actions>
                                </div>

                                
                              </td>
                            </tr>
                          </table>
                           
                        </nb-card-body>
                      </nb-card>
                       

                      
                    </div>    
    
                    <form [formGroup]="marksheets" *ngIf="marksheetss==true">
                      <div class="form-group" formArrayName="marksheet"
                        *ngFor="let marksheet of marksheets.get('marksheet')['controls']; let i = index;">
                        <div class="tab1" [formGroupName]="i">
                          <h6>
                            Enter Marksheet {{i + 1}} Details
                          </h6>
    
                          <div class="from">
                            <!-- <div class="row">
                              <div class="col-md-4">
                                <mat-select class="form-control" placeholder="Select Year/Semesters" formControlName="marksheetControl">
                                  <mat-option *ngFor="let option of options" [value]="option.name">
                                    {{ option.name }}
                                </mat-option>
                              </mat-select>
                              </div>
                              <div class="col-lg-4">
                                <div style="display: flex; align-items: center;">
                                  <div style="flex: 1;">
                                    <input id="coldd" type="text" placeholder="Enter PRN Number" aria-label="Number"
                                    formControlName="prnMarksheet">
                                  </div>
                                  <button nbButton style="margin-left: 10px;" (click)="verify(i,'marksheet');" >Verify</button>
                                </div>
                              </div>
                            </div> -->
                           
                            <div class="row">
                              <div class="col-xl-4">
                                <label>College<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="College" type="text" placeholder="Select college" aria-label="course" matInput
                                  formControlName="collegeName" [matAutocomplete]="collegeAuto" (focusout)="selectColleges_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn2" #collegeAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredOptions6[i] | async" [value]="option.college_name"
                                  (click)="setToOtherFields('marksheet',option.term_name,i,'college')">
                                    {{option.college_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(marksheet.get('collegeName').errors && (marksheet.get('collegeName').dirty || marksheet.get('collegeName').touched))" >
                                  <div *ngIf="marksheet.get('collegeName').errors.required"><span style="color:red; font-weight:bold;">College should be required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <label>Course<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="marksheetCourse" type="text" placeholder="Select Course" aria-label="course"
                                  formControlName="courseName" [matAutocomplete]="marksheetAuto" (focusout)="selectCourse_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn" #marksheetAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredCourses" [value]="option.course_name"
                                    (click)="setToOtherFields('marksheet',option.course,i,'course')">
                                    {{option.course_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(marksheet.get('courseName').errors && (marksheet.get('courseName').dirty || marksheet.get('courseName').touched))" >
                                  <div *ngIf="marksheet.get('courseName').errors.required"><span style="color:red; font-weight:bold;">Course should be required.</span></div>
                                </div> 
                              </div>
                              <div class="col-xl-4">
                                <label>Course Type<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="courseType" placeholder="select Course Type" (selectionChange)="deselectTranscript($event);" >
                                  <mat-option *ngFor="let option of courseTypes" [value]="option.type"
                                    (click)="setToOtherFields('marksheet',option.type,i,'courseType')">
                                    {{option.type}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(marksheet.get('courseType').errors && (marksheet.get('courseType').dirty || marksheet.get('courseType').touched))" >
                                  <div *ngIf="marksheet.get('courseType').errors.required"><span style="color:red; font-weight:bold;">Course Type should be required.</span></div>
                                </div> 
                              </div>

                              <div class="col-xl-4">
                                <label>Examination pattern<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="pattern" placeholder="select Examination pattern"
                                  (selectionChange)="getCourseDetails(marksheets.controls['marksheet'].controls[i].controls.courseName.value,$event)" >
                                  <mat-option *ngFor="let option of patterns" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(marksheet.get('pattern').errors && (marksheet.get('pattern').dirty || marksheet.get('pattern').touched))" >
                                  <div *ngIf="marksheet.get('pattern').errors.required"><span style="color:red; font-weight:bold;">Examination pattern is required.</span></div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <label
                                  *ngIf="marksheets.controls['marksheet'].controls[i].controls.pattern.value == null">Year/Semesters</label>
                                <label
                                  *ngIf="marksheets.controls['marksheet'].controls[i].controls.pattern.value == 'Annual'">Annual</label>
                                <label
                                  *ngIf="marksheets.controls['marksheet'].controls[i].controls.pattern.value == 'Semester'">Semester</label><span style="color:red; font-weight:bold">*</span>
    
                                <br />
                                <input id="semester" type="text" [placeholder]=patternType aria-label="course"
                                  formControlName="semester" [matAutocomplete]="semester" >
                                <mat-autocomplete [displayWith]="displayFn1" #semester="matAutocomplete">
                                  <mat-option *ngFor="let option of courseDetails" [value]="option.term_name"
                                    (click)="setToOtherFields('marksheet',option.term_name,i,'sem_year')">
                                    {{option.term_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(marksheet.get('semester').errors && (marksheet.get('semester').dirty || marksheet.get('semester').touched))" >
                                  <div *ngIf="marksheet.get('semester').errors.required"><span style="color:red; font-weight:bold;">Semester is required.</span></div>
                                </div> 
                              </div>
                              <div class="col-md-4">
                                <label>Seat No./ Roll No.<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  formControlName="seatNo" placeholder="Seat Number" onkeypress="return event.charCode >=48 && event.charCode <=57 || 
                                (event.charCode > 64 && event.charCode < 91) || 
                                (event.charCode > 96 && event.charCode < 123) && (event.charCode!==32)"
                                  (focus)="setToOtherFields('marksheet',marksheets.controls['marksheet'].controls[i].controls.semester.value,i,'sem_year')" />
                                  <div *ngIf="(marksheet.get('seatNo').errors && (marksheet.get('seatNo').dirty || marksheet.get('seatNo').touched))" >
                                    <div *ngIf="marksheet.get('seatNo').errors.required"><span style="color:red; font-weight:bold;">seat Number is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Passing Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  matInput [matDatepicker]="dp" [max]="today" formControlName="passingMonthYear"
                                  (focus)="dp.open()"
                                  (focus)="setToOtherFields('marksheet',marksheets.controls['marksheet'].controls[i].controls.semester.value,i,'sem_year')"
                                  readonly />
                                <mat-datepicker #dp startView="multi-year"
                                (monthSelected)="chosenMonthHandler($event,dp,'marksheet',i,'passing')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>

                              <div class="col-xl-4" *ngIf="marksheets.controls['marksheet'].controls[i].controls.mbaCheck.value == true">
                                <label>Studied From Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp5" formControlName="fromMonthYear" (focus)="dp5.open()"
                                  readonly />
                                <mat-datepicker  #dp5 startView="multi-year"
                                  (monthSelected)="chosenMonthHandler($event,dp5,'marksheet',i,'from')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4" *ngIf="marksheets.controls['marksheet'].controls[i].controls.mbaCheck.value == true">
                                <label>Studied To Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp4" formControlName="toMonthYear" (focus)="dp4.open()"
                                  readonly />
                                <mat-datepicker #dp4 startView="multi-year"
                                  (monthSelected)="chosenMonthHandler($event,dp4,'marksheet',i,'to')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4" *ngIf="marksheets.controls['marksheet'].controls[i].controls.mbaCheck.value == true">
                                <label>Elective Group<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="majorSubject" />
                                <div *ngIf="(marksheet.get('majorSubject').errors && (marksheet.get('majorSubject').dirty || marksheet.get('majorSubject').touched))" >
                                  <div *ngIf="marksheet.get('majorSubject').errors.required"><span style="color:red; font-weight:bold;">Elective Group is required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4" *ngIf="marksheets.controls['marksheet'].controls[i].controls.mbaCheck.value == true">
                                <label>Total Grade Points<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="totalGrade" />
                                <div *ngIf="(marksheet.get('totalGrade').errors && (marksheet.get('totalGrade').dirty || marksheet.get('totalGrade').touched))" >
                                  <div *ngIf="marksheet.get('totalGrade').errors.required"><span style="color:red; font-weight:bold;">Total Grade Point is required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4" *ngIf="marksheets.controls['marksheet'].controls[i].controls.mbaCheck.value == true">
                                <label>Average Grade Points<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="avgGrade" />
                                <div *ngIf="(marksheet.get('avgGrade').errors && (marksheet.get('avgGrade').dirty || marksheet.get('avgGrade').touched))" >
                                  <div *ngIf="marksheet.get('avgGrade').errors.required"><span style="color:red; font-weight:bold;">Average Grade Point is required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <label>Result Class<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="result" placeholder="select result class" >
                                  <mat-option *ngFor="let option of resultClasses" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(marksheet.get('result').errors && (marksheet.get('result').dirty || marksheet.get('result').touched))" >
                                  <div *ngIf="marksheet.get('result').errors.required"><span style="color:red; font-weight:bold;">Result class is required.</span><br></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="font-size: 16px; color: red; font-style: italic;">
                            <b>(NOTE : Click on save button to save educational details<br> Upload document option enable
                              after saving education details)</b>
    
                            <span class="text-danger pl-1">*</span>
                          </div>&nbsp;
                          <div class="row SUbtn">
                            <div class="col-md-2">
                              <button (click)="saveDocumentsDetails('marksheet',i)">Save</button>
                            </div>
                            <div class="col-md-2">
                              <button nbButton hero status="danger" (click)="deleteDetails(marksheets.controls['marksheet'].controls[i].controls.id.value,'edu_details')">Delete</button></div>
                            <div class="col-md-6" style="display: block;">
                              <p-fileUpload chooseLabel="Upload"
                                *ngIf="marksheets.controls['marksheet'].controls[i].controls.fileName.value == null || marksheets.controls['marksheet'].controls[i].controls.fileName.value == undefined"
                                [disabled]="marksheets.controls['marksheet'].controls[i].controls.id.value == null"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{marksheets.controls['marksheet'].controls[i].controls.id.value}}&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event,i)" chooseLabel="Upload {{marksheets.controls['marksheet'].controls[i].controls.semester.value}} Marksheet"
                                (onUpload)="onUpload($event, 'marksheet',i)" (onSelect)="onSelect($event,i)"> 
                                
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="marksheets.controls['marksheet'].controls[i].controls.fileName.value">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(marksheets.controls['marksheet'].controls[i].controls.fileName.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(marksheets.controls['marksheet'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
    
                    <form [formGroup]="transcripts" *ngIf="transcriptss==true">
                      <div class="form-group" formArrayName="transcript"
                        *ngFor="let transcript of transcripts.get('transcript')['controls']; let i = index;">
                        <div class="tab2" [formGroupName]="i">
                          <h6>
                            Enter Transcript {{i + 1}} Details
                          </h6>
                          <div class="from">
                            <!-- <div class="row">
                              <div class="col-lg-4">
                                <div style="display: flex; align-items: center;">
                                  <div style="flex: 1;">
                                    <input id="coldd" type="text" placeholder="Enter PRN Number" aria-label="Number"
                                    formControlName="prnTranscipt">
                                  </div>
                                  <button nbButton style="margin-left: 10px;" (click)="verify(i,'transcript');">Verify</button>
                                </div>
                                </div></div> -->
                            <div class="row">
                                  <div class="col-xl-4">
                                    <label>College<span style="color:red; font-weight:bold">*</span></label>
                                    <br />
                                    <input id="college" type="text" placeholder="Select college" aria-label="course" matInput
                                      formControlName="collegeName" [matAutocomplete]="collegeAuto" (focusout)="selectColleges_edit($event)">
                                    <mat-autocomplete [displayWith]="displayFn2" #collegeAuto="matAutocomplete">
                                      <mat-option *ngFor="let option of filteredOptions7[i] | async" [value]="option.college_name"
                                      (click)="setToOtherFields('transcript',option.term_name,i,'college')">
                                        {{option.college_name}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <div *ngIf="(transcript.get('collegeName').errors && (transcript.get('collegeName').dirty || transcript.get('collegeName').touched))" >
                                      <div *ngIf="transcript.get('collegeName').errors.required"><span style="color:red; font-weight:bold;">College should be required.</span></div>
                                    </div>
                                  </div>

                              <div class="col-xl-4">
                                <label>Course<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="transcriptCourse" type="text" placeholder="Select Course" aria-label="course"
                                  matInput formControlName="courseName" [matAutocomplete]="transcriptAuto" (focusout)="selectCourse_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn" #transcriptAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredCourses" [value]="option.course_name"
                                    (click)="setToOtherFields('transcript',option.course,i,'course')">
                                    {{option.course_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(transcript.get('courseName').errors && (transcript.get('courseName').dirty || transcript.get('courseName').touched))" >
                                  <div *ngIf="transcript.get('courseName').errors.required"><span style="color:red; font-weight:bold;">Course should be required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <label>Course Type<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="courseType" placeholder="select Course Type" (selectionChange)="deselectTranscript($event);">
                                    <mat-option *ngFor="let option of courseTypes" [value]="option.type"
                                      (click)="setToOtherFields('transcript',option.type,i,'courseType')">
                                      {{option.type}}
                                    </mat-option>
                                  </mat-select>
                                <div *ngIf="(transcript.get('courseType').errors && (transcript.get('courseType').dirty || transcript.get('courseType').touched))" >
                                  <div *ngIf="transcript.get('courseType').errors.required"><span style="color:red; font-weight:bold;">Course Type should be required.</span></div>
                                </div> 
                              </div>

                              <div class="col-md-4">
                                <label>Seat No./ Roll No.<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="seatNo" onkeypress="return event.charCode >=48 && event.charCode <=57 || 
                                (event.charCode > 64 && event.charCode < 91) || 
                                (event.charCode > 96 && event.charCode < 123) && (event.charCode!==32)"
                                  (focus)="setToOtherFields('transcript',transcripts.controls['transcript'].controls[i].controls.courseName.value,i,'course')" />
                                <div *ngIf="(transcript.get('seatNo').errors && (transcript.get('seatNo').dirty || transcript.get('seatNo').touched))" >
                                  <div *ngIf="transcript.get('seatNo').errors.required"><span style="color:red; font-weight:bold;">Seat Number is required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Passing Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp" [max]="today" formControlName="passingMonthYear"
                                  (focus)="dp.open()" readonly
                                  (focus)="setToOtherFields('transcript',transcripts.controls['transcript'].controls[i].controls.courseName.value,i,'course')" />
                                <mat-datepicker #dp startView="multi-year"
                                  (monthSelected)="chosenMonthHandler($event,dp,'transcript',i,'')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Result Class<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="result" placeholder="select result class">
                                  <mat-option *ngFor="let option of resultClasses" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(transcript.get('result').errors && (transcript.get('result').dirty || transcript.get('result').touched))" >
                                  <div *ngIf="transcript.get('result').errors.required"><span style="color:red; font-weight:bold;">Result class is required.</span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="font-size: 16px; color: red; font-style: italic;">
                            <b>(NOTE : Click on save button to save educational details<br> Upload document option enable
                              after saving education details)</b>
    
                            <span class="text-danger pl-1">*</span>
                          </div>&nbsp;
                          <div class="row SUbtn">
                            <div class="col-md-2">
                              <button (click)="saveDocumentsDetails('transcript',i)">Save</button>
                            </div>
                            <div class="col-md-2">
                              <button nbButton hero status="danger" (click)="deleteDetails(transcripts.controls['transcript'].controls[i].controls.id.value,'edu_details')">Delete</button></div>
                            <div class="col-md-2" style="display: block;">
                              <p-fileUpload chooseLabel="Upload"
                                *ngIf="transcripts.controls['transcript'].controls[i].controls.fileName.value == null || transcripts.controls['transcript'].controls[i].controls.fileName.value == undefined"
                                [disabled]="transcripts.controls['transcript'].controls[i].controls.id.value == null"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{transcripts.controls['transcript'].controls[i].controls.id.value}}&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                                (onSelect)="onSelect($event)">
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="transcripts.controls['transcript'].controls[i].controls.fileName.value != null">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(transcripts.controls['transcript'].controls[i].controls.fileName.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(transcripts.controls['transcript'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
    
                        </div>
    
                      </div>
    
                    </form>
    
                    <form [formGroup]="degrees" *ngIf="degree==true">
                      <div class="form-group" formArrayName="degree"
                        *ngFor="let deg of degrees.get('degree')['controls']; let i = index;">
                        <div class="tab3" [formGroupName]="i">
                          <h6>
                            Enter Degree {{i + 1}} Details
                          </h6>
                          <div class="from">
                            <div class ="row">
                              <div class="col-xl-4">
                                <mat-radio-group aria-label="select degree type" formControlName="degreeTypeCtrl">
                                  <mat-radio-button value="Provisional Degree Certificate">
                                    Provisional Degree Certificate
                                  </mat-radio-button> &nbsp; &nbsp; &nbsp;
                                  <mat-radio-button value="Degree Certificate">
                                    Degree Certificate
                                  </mat-radio-button>
                                </mat-radio-group>
                              </div>
                            </div>

                            <!-- <div class="row">
                              <div class="col-lg-4">
                                <div style="display: flex; align-items: center;">
                                  <div style="flex: 1;">
                                    <input id="coldd" type="text" placeholder="Enter PRN Number" aria-label="Number"
                                    formControlName="prnDegree">
                                  </div>
                                  <button nbButton style="margin-left: 10px;" (click)="verify(i,'degree');">Verify</button>
                                </div>
                                </div></div> -->

                            <div class="row">
                              <div class="col-xl-4">
                                <label>College<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="College" type="text" placeholder="Select college" aria-label="course" matInput
                                  formControlName="collegeName" [matAutocomplete]="collegeAuto" (focusout)="selectColleges_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn2" #collegeAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredOptions8[i] | async" [value]="option.college_name"
                                  (click)="setToOtherFields('degree',option.term_name,i,'college')">
                                    {{option.college_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(deg.get('collegeName').errors && (deg.get('collegeName').dirty || deg.get('collegeName').touched))" >
                                  <div *ngIf="deg.get('collegeName').errors.required"><span style="color:red; font-weight:bold;">College should be required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <label>Course<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="degreeCourse" type="text" placeholder="Select Course" aria-label="course"
                                  matInput formControlName="courseName" [matAutocomplete]="degreeAuto" (focusout)="selectCourse_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn" #degreeAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredCourses" [value]="option.course_name">
                                    {{option.course_name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(deg.get('courseName').errors && (deg.get('courseName').dirty || deg.get('courseName').touched))" >
                                  <div *ngIf="deg.get('courseName').errors.required"><span style="color:red; font-weight:bold;">course should be required.</span></div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <label>Course Type<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="courseType" placeholder="select Course Type" (selectionChange)="deselectTranscript($event);">
                                  <mat-option *ngFor="let option of courseTypes" [value]="option.type"
                                    (click)="setToOtherFields('degree',option.type,i,'courseType')">
                                    {{option.type}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(deg.get('courseType').errors && (deg.get('courseType').dirty || deg.get('courseType').touched))" >
                                  <div *ngIf="deg.get('courseType').errors.required"><span style="color:red; font-weight:bold;">Course Type should be required.</span></div>
                                </div> 
                              </div>

                              <div class="col-xl-4">
                                <label>Seat No./ Roll No.<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="seatNo" onkeypress="return event.charCode >=48 && event.charCode <=57 || 
                                (event.charCode > 64 && event.charCode < 91) || 
                                (event.charCode > 96 && event.charCode < 123) && (event.charCode!==32)" />
                                <div *ngIf="(deg.get('seatNo').errors && (deg.get('seatNo').dirty || deg.get('seatNo').touched))" >
                                  <div *ngIf="deg.get('seatNo').errors.required"><span style="color:red; font-weight:bold;">Seat no is required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Passing Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp" formControlName="passingMonthYear" (focus)="dp.open()"
                                  readonly />
                                <mat-datepicker #dp startView="multi-year" [max]="max"
                                  (monthSelected)="chosenMonthHandler($event,dp,'degree',i,'')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4" *ngIf="this.degrees.get('degree')['controls'][i].get('degreeTypeCtrl').value=='Degree Certificate'">
                                <label>
                                  Convocation Date<span style="color:red; font-weight:bold">*</span>
                                </label>
                                <input nbInput [nbDatepicker]="picker" formControlName="convocationDate" placeholder="Select date">
                                <nb-datepicker [max]="max" #picker></nb-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Result Class<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="result" placeholder="select result class">
                                  <mat-option *ngFor="let option of resultClasses" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(deg.get('result').errors && (deg.get('result').dirty || deg.get('result').touched))" >
                                  <div *ngIf="deg.get('result').errors.required"><span style="color:red; font-weight:bold;">Result class is required.</span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="font-size: 16px; color: red; font-style: italic;">
                            <b>(NOTE : Click on save button to save educational details<br> Upload document option enable
                              after saving education details)</b>
    
                            <span class="text-danger pl-1">*</span>
                          </div>&nbsp;
                          <div class="row SUbtn">
                            <div class="col-md-2">
                              <button (click)="saveDocumentsDetails('degree',i)">Save</button>
                            </div>
                            <div class="col-md-2">
                              <button nbButton hero status="danger" (click)="deleteDetails(degrees.controls['degree'].controls[i].controls.id.value,'edu_details')">Delete</button></div>
                            <div class="col-md-2">
                              <p-fileUpload chooseLabel="Upload"
                                *ngIf="degrees.controls['degree'].controls[i].controls.fileName.value == null || degrees.controls['degree'].controls[i].controls.fileName.value == undefined"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                [disabled]="degrees.controls['degree'].controls[i].controls.id.value == null"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{degrees.controls['degree'].controls[i].controls.id.value}}&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                                (onSelect)="onSelect($event)">
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="degrees.controls['degree'].controls[i].controls.fileName.value != null">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(degrees.controls['degree'].controls[i].controls.fileName.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(degrees.controls['degree'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
                        </div>
                      </div>
    
                    </form>
    
                    <form [formGroup]="secondYears" *ngIf="secondYearss==true">
                      <div class="form-group" formArrayName="secondYear"
                        *ngFor="let second of secondYears.get('secondYear')['controls']; let i = index;">
                        <div class="tab4" [formGroupName]="i">
                          <h6>
                            Enter Second Year Marksheet Details
                          </h6>
                          <div class="from">
                            <div class="row">
                              <div class="col-xl-4">
                                <label>College<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="college" type="text" placeholder="Select college" aria-label="course" matInput
                                  formControlName="collegeName" [matAutocomplete]="collegeAuto" (focusout)="selectColleges_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn2" #collegeAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredOptions5[i] | async" [value]="option.name"
                                    (click)="getCourses(option.name)">
                                    {{option.name}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(second.get('collegeName').errors && (second.get('collegeName').dirty || second.get('collegeName').touched))" >
                                  <div *ngIf="second.get('collegeName').errors.required"><span style="color:red; font-weight:bold;">College should be required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Course<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input id="secondYearCourse" type="text" placeholder="Select Course" aria-label="course"
                                  matInput formControlName="courseName" [matAutocomplete]="secondYearAuto" (focusout)="selectCourse_edit($event)">
                                <mat-autocomplete [displayWith]="displayFn" #secondYearAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredOptions4[i] | async" [value]="option.course">
                                    {{option.course}}
                                  </mat-option>
                                </mat-autocomplete>
                                <div *ngIf="(second.get('courseName').errors && (second.get('courseName').dirty || second.get('courseName').touched))" >
                                  <div *ngIf="second.get('courseName').errors.required"><span style="color:red; font-weight:bold;">Course should be required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Course Type<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="courseType" placeholder="select Course Type" (selectionChange)="deselectTranscript($event);">
                                  <mat-option *ngFor="let option of courseTypes" [value]="option.type">
                                    {{option.type}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(second.get('courseType').errors && (second.get('courseType').dirty || second.get('courseType').touched))" >
                                  <div *ngIf="second.get('courseType').errors.required"><span style="color:red; font-weight:bold;">Course Type should be required.</span></div>
                                </div> 
                              </div>
                              <div class="col-xl-4">
                                <label>Studied From Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp1" formControlName="fromMonthYear" (focus)="dp1.open()"
                                  readonly />
                                <mat-datepicker [max]="today" #dp1 startView="multi-year"
                                  (monthSelected)="chosenMonthHandler($event,dp1,'secondYear',i,'from')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Studied To Month-Year<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput [matDatepicker]="dp2" formControlName="toMonthYear" (focus)="dp2.open()"
                                  readonly />
                                <mat-datepicker #dp2 startView="multi-year"
                                  (monthSelected)="chosenMonthHandler($event,dp2,'secondYear',i,'to')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Major Subject<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="majorSubject" />
                                <div *ngIf="(second.get('majorSubject').errors && (second.get('majorSubject').dirty || second.get('majorSubject').touched))" >
                                  <div *ngIf="second.get('majorSubject').errors.required"><span style="color:red; font-weight:bold;">Major Subject is required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Subsidary Subject<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input matInput formControlName="subsidarySubject" />
                                <div *ngIf="(second.get('subsidarySubject').errors && (second.get('subsidarySubject').dirty || second.get('subsidarySubject').touched))" >
                                  <div *ngIf="second.get('subsidarySubject').errors.required"><span style="color:red; font-weight:bold;">Subsidiary Subject is required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-4">
                                <label>Examination pattern<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" placeholder="select Examination pattern" formControlName="pattern">
                                  <mat-option *ngFor="let option of patterns" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(second.get('pattern').errors && (second.get('pattern').dirty || second.get('pattern').touched))" >
                                  <div *ngIf="second.get('pattern').errors.required"><span style="color:red; font-weight:bold;">pattern is required.</span></div>
                                </div>
                              </div>
                            </div>
                            <br />
                            <span
                              *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Semester'"
                              style="font-weight:bold;">Semester III</span>
                            <div class="row">
                              <div class="col-xl-4">
                                <label>
                                  Passing Month-Year<span style="color:red; font-weight:bold">*</span>
                                </label>
                                <br />
                                <input matInput [matDatepicker]="dp" formControlName="passingMonthYear" (focus)="dp.open()"
                                  readonly />
                                <mat-datepicker #dp startView="multi-year" [max]="today"
                                  (monthSelected)="chosenMonthHandler($event,dp,'secondYear',i,'passing')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Result Class<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="result" placeholder="select result class">
                                  <mat-option *ngFor="let option of resultClasses" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(second.get('result').errors && (second.get('result').dirty || second.get('result').touched))" >
                                  <div *ngIf="second.get('result').errors.required"><span style="color:red; font-weight:bold;">Result class is required.</span></div>
                                </div>
                              </div>
                            </div>
                            <br />
                            <span
                              *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Semester'"
                              style="font-weight:bold;">Semester IV</span>
                            <div class="row"
                              *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Semester'">
                              <div class="col-xl-4">
                                <label>
                                  Passing Month-Year<span style="color:red; font-weight:bold">*</span>
                                </label>
                                <br />
                                <input matInput [matDatepicker]="dp3" formControlName="passingMonthYear2"
                                  (focus)="dp3.open()" readonly />
                                <mat-datepicker #dp3 startView="multi-year" [max]="today"
                                  (monthSelected)="chosenMonthHandler($event,dp3,'secondYear',i,'passing2')"
                                  panelClass="example-month-picker">
                                </mat-datepicker>
                              </div>
                              <div class="col-xl-4">
                                <label>Result Class<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <mat-select class="form-control" formControlName="result2" placeholder="select result class">
                                  <mat-option *ngFor="let option of resultClasses" [value]="option.name">
                                    {{option.name}}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="(second.get('result2').errors && (second.get('result2').dirty || second.get('result2').touched))" >
                                  <div *ngIf="second.get('result2').errors.required"><span style="color:red; font-weight:bold;">Result Class is required.</span></div>
                                </div>

                              </div>
                            </div>
    
                          </div>
                          <div class="row" style="font-size: 16px; color: red; font-style: italic;">
                            <b>(NOTE : Click on save button to save educational details<br> Upload document option enable
                              after saving education details)</b>
    
                            <span class="text-danger pl-1">*</span>
                          </div>&nbsp;
                          <div class="row SUbtn">
                            <div class="col-md-2">
                              <button (click)="saveDocumentsDetails('secondYear',i)">Save</button>
                            </div>
                          </div>
                          <br />
                          <div class="row SUbtn">
                            <div class="col-md-4">
                              Upload
                              <span
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Semester'">
                                Semester III
                              </span>
                              <span
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Annual'">
                                Second Year
                              </span>
                              file
                            </div>
                            <div class="col-md-4">
                              <p-fileUpload chooseLabel="Upload"
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName.value == null || secondYears.controls['secondYear'].controls[i].controls.fileName.value == undefined"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                [disabled]="secondYears.controls['secondYear'].controls[i].controls.id.value == null"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{secondYears.controls['secondYear'].controls[i].controls.id.value}}&type=secondYear&pattern={{secondYears.controls['secondYear'].controls[i].controls.pattern.value}}&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                                (onSelect)="onSelect($event)">
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName.value != null">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(secondYears.controls['secondYear'].controls[i].controls.fileName.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(secondYears.controls['secondYear'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
                          <br />
                          <div class="row SUbtn"
                            *ngIf="secondYears.controls['secondYear'].controls[i].controls.pattern.value == 'Semester'">
                            <div class="col-md-4">
                              Upload Semester IV file
                            </div>
                            <div class="col-md-4">
                              <p-fileUpload chooseLabel="Upload"
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName2.value == null || secondYears.controls['secondYear'].controls[i].controls.fileName2.value == undefined"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                [disabled]="secondYears.controls['secondYear'].controls[i].controls.id.value == null"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{secondYears.controls['secondYear'].controls[i].controls.id.value}}&type=secondYear&pattern={{secondYears.controls['secondYear'].controls[i].controls.pattern.value}}&semester=Semester IV&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                                (onSelect)="onSelect($event)">
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName2.value != null">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(secondYears.controls['secondYear'].controls[i].controls.fileName2.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(secondYears.controls['secondYear'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
                          <br />
                          <div class="row SUbtn">
                            <div class="col-md-4">
                              Upload College NOC Letter
                            </div>
                            <div class="col-md-4">
                              <button size="x-small" status="info" nbPopover="Click here to Download letter" nbPopoverMode="hover"  (click)="downloadLetter();" nbButton>Download NOC Letter</button>
                            </div>
                            <div class="col-md-4">
                              <p-fileUpload chooseLabel="Upload NOC Letter"
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName3.value == null || secondYears.controls['secondYear'].controls[i].controls.fileName3.value == undefined"
                                name="file" mode="basic" auto="true" [accept]="'.pdf,.jpg,.png'"
                                [disabled]="secondYears.controls['secondYear'].controls[i].controls.id.value == null"
                                url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&doc_id={{secondYears.controls['secondYear'].controls[i].controls.id.value}}&type=secondYear&errata=false"
                                maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                                (onSelect)="onSelect($event)">
                              </p-fileUpload>
    
                              <nb-actions size="medium" fullWidth
                                *ngIf="secondYears.controls['secondYear'].controls[i].controls.fileName3.value != null">
                                <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-eye" title="View File"
                                  (click)="imagePopup(secondYears.controls['secondYear'].controls[i].controls.fileName3.value,'edu_document'); ">
                                </nb-action>&nbsp;&nbsp;&nbsp;&nbsp;
                                <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;" class="control-item"
                                  class="ion ion-ios-trash" title="Delete File"
                                  (click)="deleteDocument(secondYears.controls['secondYear'].controls[i].controls.id.value,'edu_document')">
                                </nb-action>
                              </nb-actions>
                            </div>
                          </div>
                        </div>
                      </div>
    
                    </form>
                  </div>
                  <div class="col-xl-3" style="text-align: center;">
                    <div class="row">
                      <div class="col-xl-2"></div>
                      <div class="col-xl-8" style="padding-top:100px;">
                        <p style="font-size: 150%"><b>Need Help?</b></p><br>
                        <img class="videoimg"  src="{{imageUrl}}/api/upload/profile_pic/PLAY.png" data-toggle="modal" width="100px;" data-height="100px;" data-target="#myModal" data-video-fullscreen=""  (click)="videoPopup(2)">
                        <br>
                        <b>कोणत्याही प्रश्नासाठी, कृपया आम्हाला<a style="color:#40dc7e">{{helpEmailId}}</a>वर ईमेल करा किंवा {{helpMobNo}} वर संपर्क साधा</b>
                      </div>
                      <div class="col-md-2"></div>
                    </div>
                    
                  </div>
                </div>
                

                <div *ngIf="(transcriptss && showTranscript) || (degree && showDegreet)">
                  <label  style="color: black; font-weight: bold; font-size: 18px;">Supportive Document</label>
                  <nb-card>
                    <nb-card-body style="display: flex; flex-wrap: wrap;">
                      <div class="col-xl-4">
                        <label>Course</label>
                        <br />
                        <input id="course" type="text" placeholder="Select Course" aria-label="course" matInput
                          [(ngModel)]="courseName" [matAutocomplete]="courseAuto"
                          [matAutocompleteDisabled]="!courseAuto">
                        <mat-autocomplete [displayWith]="displayFn" #courseAuto="matAutocomplete">
                          <mat-option *ngFor="let option of courseData " [value]="option.course_name">
                            {{option.course_name}}
                          </mat-option>
                        </mat-autocomplete>
                      </div>
                      <div class="col-xl-4">
                        <label>Select Pattern</label>
                        <br />
                        <mat-select class="form-control" [(ngModel)]="patternSup"
                          placeholder="select Examination pattern" (selectionChange)="onPatternSelection($event)">
                          <mat-option *ngFor="let option of patterns" [value]="option.name">
                            {{option.name}}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-md-4">
                        <label *ngIf="patternValue == null">Year/Semesters</label>
                        <label *ngIf="patternValue == 'Annual'">Annual</label>
                        <label *ngIf="patternValue == 'Semester'">Semester</label><span
                          style="color:red; font-weight:bold">*</span>
                        <br />
                        <input id="semester" type="text" placeholder="Select {{patternValue}} " aria-label="course"
                          [(ngModel)]="pattern_Type" (ngModelChange)="checkFormValidity()" [matAutocomplete]="semester" [matAutocompleteDisabled]="!semester">
                        <mat-autocomplete [displayWith]="displayFn1" #semester="matAutocomplete">
                          <mat-option *ngFor="let option of valueOfPattern" [value]="option.term_name">
                            {{option.term_name}}
                          </mat-option>
                        </mat-autocomplete>
                      </div>
                      <br><br>
                      <div class="col-xl-4" style="flex: 1; min-width: 100%;">
                        <p-fileUpload chooseLabel="Upload" name="file" mode="basic" auto="true"
                          [accept]="'.pdf,.jpg,.png'"
                          url="{{uploadUrl}}/agent/uploadDocument?user_id={{user_id}}&type=supportive&semester={{pattern_Type}}&courseName={{courseName}}&errata=false"
                          maxFileSize="5000000" (onBeforeSend)="onBeforeSend($event)" (onUpload)="onUpload($event)"
                          (onSelect)="onSelect($event)" [disabled]="!isFormValid">
                        </p-fileUpload>
                        
                        <br><br>
                        <div *ngFor="let fileData of data">
                          <nb-card *ngIf="fileData.file !== null">
                            <ul style="display: flex; justify-content: space-between; align-items: center; padding: 6px;">
                              <li>
                                <span style="font-weight: bold;">{{fileData.semester}} </span>
                              </li>
                              <li style="display: flex; align-items: center;">
                                <nb-actions size="medium">
                                  <nb-action style="color:rgb(30, 35, 107);font-size: 1.5rem;"
                                    class="control-item ion ion-ios-eye" title="View File"
                                    (click)="imagePopup(fileData?.file,'edu_document')">
                                  </nb-action>
                                </nb-actions>
                              </li>
                                 <nb-actions size="medium">
                                  <nb-action style="color:rgb(206, 6, 6);font-size: 1.5rem;"
                                    class="control-item ion ion-ios-trash" title="Delete File"
                                    (click)="deleteDetails(fileData?.id,'edu_details')">
                                  </nb-action>
                                </nb-actions>
                                  </ul>
                          </nb-card>
                        </div>
  
                      </div>
                    </nb-card-body>
                  </nb-card>

                </div>

                <div class="navebtn" class="footer-btn" style="margin-top: 6%;">
                  <button (click)="prevStep();" nbButton>previous</button>
                  <button (click)="nextStep();" style="margin-left: 5%;" nbButton>next</button>
                </div>
              </div>
            </nb-step>

            <nb-step [completed]="tabcheck3" label="Institute Details">
              <div class="fontmedia">
                <h2>Institute Details  (संस्था तपशील)</h2>
              </div>
              <div *ngIf="(language=='English') || (language == null || language == undefined ) ">
                <div style="text-align: left; ">
                  <h5>Instructions (सूचना)</h5>
                  <ul>
                    <!-- <li style="color: red;"><b> Normal delivery mode takes 30 days to process the application</b></li> -->
                    <!-- <li style="color: red;"><b> Urgent delivery mode takes 5 days to process the application</b></li> -->
                    <li style="color: black;"><b> अर्जदाराने इन्स्टिट्यूट/एजन्सी/नियोक्त्याचा संदर्भ क्रमांक (Reference Number), नाव आणि ईमेल आयडी इनपुट करणे आवश्यक आहे जेथे ते सत्यापन पत्र (Verification Letter) पाठवू इच्छितात.</b>
                    </li>
                    <li style="color: black;"><b>संदर्भ क्रमांक (Reference No) हा युनिक आयडेंटिफिकेशन नंबर आहे ज्यावर आधारित तुमची संस्था/एजन्सी तुमची कागदपत्रे ओळखेल.
                     </b></li>
                  </ul>                </div>
                </div>
                <div *ngIf="language=='Gujarati'">
                <div style="text-align: left; ">
                  <h5>સૂચનાઓ</h5>
                  <ul>
                    <!-- <li style="color: red;"><b> Normal delivery mode takes 30 days to process the application</b></li> -->
                    <!-- <li style="color: red;"><b> Urgent delivery mode takes 5 days to process the application</b></li> -->
                    <li style="color: red;"><b> એપ્લિકંટ એ સંસ્થા/એજન્સી/ એમ્પ્લોયર નો સંદર્ભ નંબર, નામ અને ઈમેઈલ આઈડી દાખલ કરવાની જરૂર
                      છે જ્યાં તેઓ વેરિફિકેશન લેટર મોકલવા ઈચ્છે છે.</b>
                    </li>
                    <li style="color: red;"><b> સંદર્ભ નંબર એ અનન્ય ઓળખ નંબર છે જેના આધારે તમારી સંસ્થા/એજન્સી તમારા ડોક્યુમેન્ટ્સ ને
                      ઓળખશે.</b>
                      <li style="color: red;"><b> જો એપ્લિકંટ પોતાના માટે વેરિફિકેશન લેટર કોપી મેળવવા ઈચ્છે તો તેમનું નામ, ઇનપુટ N/A – લાગુ પડતું
                        નથી અને ડીજીટલ કોપી માટે સીલબંધ કોપી/ઇમેઇલ આઈડી માટે તેમનું સરનામું ઇનપુટ કરી શકે છે.
                        સીલબંધ કોપી પસંદ કરવાની જરૂર નથી.</b>
                      </li>
                      <li style="color: red;"><b> સીલબંધ પરબિડીયુંના કિસ્સામાં, પ્રાપ્તકર્તાનું સંપૂર્ણ સરનામું ઉમેરો</b>
                      </li>
                      <li style="color: red;"><b> જો એપ્લિકંટ બહુવિધ સરનામાંઓ પર એકથી વધુ કોપી ઓ મોકલવા માંગે છે, તો તેણે કોપી ની સંખ્યા
                        સિલેક્ટ કરવી આવશ્યક છે અને તે મુજબ સરનામાં ઇનપુટ કરવા આવશ્યક છે.</b>
                      </li>
                      <li style="color: red;"><b> એપ્લિકંટ એ આગળ વધતા પહેલા વિગતો સેવ કરવી આવશ્યક છે.</b>
                      </li>
                      <li style="color: red;"><b> નોંધ: મહેરબાની કરીને નોંધ કરો કે ગુજરાત યુનિવર્સિટી માત્ર ગુજરાત યુનિવર્સિટી સાથે સંલગ્ન કોલેજોના દસ્તાવેજોને પ્રમાણિત/ચકાસણી કરી શકે છે.</b></li>
                  </ul>
                </div>
                </div>

              <nb-card style="padding: 0%;">

                <!-- <nb-card-header *ngIf="viewInstitute == false"
                  style="border-bottom: solid 1px black; margin-bottom: 2%;">
                  <div class="row">
                    <div class="col-xl-3">
                      <label>Select the delivery mode option :</label>
                    </div>
                    <div class="col-xl-3">
                      <nb-radio-group name="deliveryMode" [(ngModel)]="selectedDeliveryMode"
                        (ngModelChange)="selectDeliveryOption()">
                        <nb-radio value="Normal">Normal</nb-radio>
                        <nb-radio value="Urgent">Urgent</nb-radio>
                      </nb-radio-group>
                    </div>
                  </div>

                </nb-card-header> -->

                <nb-card-header *ngIf="viewInstitute == true" style="padding: 0%;">
                  <!-- <div class="row">
                    <div class="col-xl-4">
                      Delivery Mode : {{selectedDelivery}} - {{selectedDeliveryMode}}
                    </div>
                    <div class="col-xl-2 SUbtn">
                      <button (click)="changeDeliveryMode()">Change</button>
                    </div>
                  </div> -->
                </nb-card-header>

                <nb-card-body>
                  <div class="row">
                    <div class="col-xl-9">
                      <div class="tabset">
                        <div class="tabsets" (click)="InMarksheets()" *ngIf="verificationTypes?.marksheet == true">
                          <h6 [ngClass]="{'tabsets1':Inmarksheetss ,'tabsets':!Inmarksheetss}">
                            Marksheets
                          </h6>
                        </div>
                        <div class="tabsets" (click)="InTranscripts()" *ngIf="verificationTypes?.transcript == true">
                          <h6 [ngClass]="{'tabsets1':Intranscriptss ,'tabsets':!Intranscriptss}">
                            Transcripts
                          </h6>
                        </div>
                        <div class="tabsets" (click)="InDegree()" *ngIf="verificationTypes?.degreeCertificate == true">
                          <h6 [ngClass]="{'tabsets1':Indegree ,'tabsets':!Indegree}">
                            Degree Certificate
                          </h6>
                        </div>
                        <div class="tabsets" (click)="InsecondYear()" *ngIf="verificationTypes?.secondYear == true">
                          <h6 [ngClass]="{'tabsets1':InsecondYearss ,'tabsets':!InsecondYearss}">
                            Second Year Marksheet
                          </h6>
                        </div>
                      </div>
    
                      <form [formGroup]="marksheets" class="InstituteDetails" *ngIf="Inmarksheetss==true">
                        <div class="form-group" formArrayName="marksheetInstitute"
                          *ngFor="let marksheet of marksheets.get('marksheetInstitute')['controls']; let i = index;">
                          <div class="tab1" [formGroupName]="i">
                            <h5>Institute/ Agency/ Company</h5>
                            <h6>Enter {{i + 1}} Details</h6><span style="color:red; font-weight:bold;">Read the filled details carefully and save details by clicking on save</span>
                            <div class="row">
                              <div class="col-xl-3">
                                <label >Reference No<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input class="form-control" type="text" nbInput formControlName="referenceNo" style="border: 1px solid black"
                                  (blur)="setToOtherFields('marksheet',$event,i,'refNO')">
                                  <div *ngIf="(marksheet.get('referenceNo').errors && marksheet.get('referenceNo').errors.required)">
                                    <div *ngIf="(marksheet.get('referenceNo').errors && (marksheet.get('referenceNo').dirty || marksheet.get('referenceNo').touched))"><span style="color:red; font-weight:bold;">Reference number is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3">
                                <label>Name<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input class="form-control" type="text" nbInput formControlName="name" style="border: 1px solid black"
                                  (blur)="setToOtherFields('marksheet',$event,i,'instName')">
                                  <div *ngIf="(marksheet.get('name').errors && marksheet.get('name').errors.required)"  >
                                    <div *ngIf="(marksheet.get('name').errors && (marksheet.get('name').dirty || marksheet.get('name').touched))"><span style="color:red; font-weight:bold;">Name is required.</span>Name is required.</div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Physical'">
                                <label>Address<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input class="form-control" type="textarea" nbInput formControlName="address" style="border: 1px solid black"
                                  (blur)="setToOtherFields('marksheet',$event,i,'address')">
                                  <div *ngIf="(marksheet.get('address').errors && marksheet.get('address').errors.required)">
                                    <div *ngIf="(marksheet.get('address').errors && (marksheet.get('address').dirty || marksheet.get('address').touched))" ><span style="color:red; font-weight:bold;">Address is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Digital'">
                                <label>email<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <!-- <input type="text" nbInput formControlName="email"> -->
                                <input type="email" class="form-control" formControlName="email"  style="border: 1px solid black" (blur)="setToOtherFields('marksheet',$event,i,'email')" />
                                  <div *ngIf="(marksheet.get('email').errors && (marksheet.get('email').dirty || marksheet.get('email').touched))"><span style="color:red; font-weight:bold;">Email address is required.</span></div>
                              </div>
                            </div>
                            <div class="row SUbtn">
                              <div class="col-md-2">
                                <button (click)="saveInstituteDetails('marksheet',i)" style="border: 1px solid black">Save</button>
                              </div>
                              <div class="col-md-2">
                                <button nbButton hero status="danger" (click)="deleteDetails(marksheets.controls['marksheetInstitute'].controls[i].controls.id.value,'Ins_details')">Delete</button></div>
                            </div>
                          </div>
                        </div>
                      </form>
    
                      <form [formGroup]="transcripts" class="InstituteDetails" *ngIf="Intranscriptss==true">
                        <div class="form-group" formArrayName="transcriptInstitute"
                          *ngFor="let transcript of transcripts.get('transcriptInstitute')['controls']; let i = index;">
                          <div class="tab1" [formGroupName]="i">
                            <h5>Institute/ Agency/ Company</h5>
                            <h6>Enter {{i + 1}} Details</h6><span style="color:red; font-weight:bold;">Read the filled details carefully and save details by clicking on save</span>
                            <div class="row">
                              <div class="col-xl-3">
                                <label>Reference No<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  class="form-control" type="text" nbInput formControlName="referenceNo" style="border: 1px solid black"
                                  (blur)="setToOtherFields('transcript',$event,i,'refNO')">
                                  <div *ngIf="(transcript.get('referenceNo').errors && transcript.get('referenceNo').errors.required)"  >
                                    <div *ngIf="(transcript.get('referenceNo').errors && (transcript.get('referenceNo').dirty || transcript.get('referenceNo').touched))"><span style="color:red; font-weight:bold;">Reference number is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3">
                                <label>Name<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input class="form-control" type="text" nbInput formControlName="name" style="border: 1px solid black"
                                  (blur)="setToOtherFields('transcript',$event,i,'instName')">
                                <div *ngIf="(transcript.get('name').errors && transcript.get('name').errors.required)"  >
                                  <div *ngIf="(transcript.get('name').errors && (transcript.get('name').dirty || transcript.get('name').touched))"><span style="color:red; font-weight:bold;">Name is required.</span></div>
                                </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Physical'">
                                <label>Address<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  class="form-control" type="textarea" nbInput formControlName="address" style="border: 1px solid black"
                                  (blur)="setToOtherFields('transcript',$event,i,'address')">
                                  <div *ngIf="(transcript.get('address').errors && transcript.get('address').errors.required)"  >
                                    <div *ngIf="(transcript.get('address').errors && (transcript.get('address').dirty || transcript.get('address').touched))"><span style="color:red; font-weight:bold;">Address is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Digital'">
                                <label>email<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <!-- <input type="text" nbInput formControlName="email"> -->
                                <input type="email" class="form-control" formControlName="email" style="border: 1px solid black" (blur)="setToOtherFields('transcript',$event,i,'email')" />
                                  <div *ngIf="(transcript.get('email').errors && (transcript.get('email').dirty || transcript.get('email').touched))"><span style="color:red; font-weight:bold;">Email address is required.</span></div>
                              </div>
                            </div>
                            <div class="row SUbtn">
                              <div class="col-md-2">
                                <button (click)="saveInstituteDetails('transcript',i)" style="border: 1px solid black">Save</button>
                              </div>
                              <div class="col-md-2">
                                <button nbButton hero status="danger" (click)="deleteDetails(transcripts.controls['transcriptInstitute'].controls[i].controls.id.value,'Ins_details')">Delete</button></div>
                            </div>
                          </div>
                        </div>
                      </form>
    
                      <form [formGroup]="degrees" class="InstituteDetails" *ngIf="Indegree==true">
                        <div class="form-group" formArrayName="degreeInstitute"
                          *ngFor="let degree of degrees.get('degreeInstitute')['controls']; let i = index;">
                          <div class="tab1" [formGroupName]="i">
                            <h5>Institute/ Agency/ Company</h5>
                            <h6>Enter {{i + 1}} Details</h6><span style="color:red; font-weight:bold;">Read the filled details carefully and save details by clicking on save</span>
                            <div class="row">
                              <div class="col-xl-3">
                                <label>Reference No<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  class="form-control" type="text" nbInput formControlName="referenceNo" style="border: 1px solid black"
                                  (blur)="setToOtherFields('degree',$event,i,'refNO')">
                                  <!-- <div *ngIf="(degree.get('referenceNo').errors && degree.get('referenceNo').errors.required)"  >
                                    <div *ngIf="(degree.get('referenceNo').errors && (degree.get('referenceNo').dirty || dgeree.get('referenceNo').touched))"><span style="color:red; font-weight:bold;">Reference number is required.</span></div>
                                  </div> -->
                              </div>
                              <div class="col-xl-3">
                                <label>Name<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  type="text" nbInput formControlName="name" style="border: 1px solid black"
                                  (blur)="setToOtherFields('degree',$event,i,'instName')">
                                  <div *ngIf="(degree.get('name').errors && degree.get('name').errors.required)"  >
                                    <div *ngIf="(degree.get('name').errors && (degree.get('name').dirty || degree.get('name').touched))"><span style="color:red; font-weight:bold;">Name is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Physical'">
                                <label>Address<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  type="textarea" nbInput formControlName="address" style="border: 1px solid black"
                                  (blur)="setToOtherFields('degree',$event,i,'address')">
                                  <div *ngIf="(degree.get('address').errors && degree.get('address').errors.required)"  >
                                    <div *ngIf="(degree.get('address').errors && (degree.get('address').dirty || degree
                                    .get('address').touched))"><span style="color:red; font-weight:bold;">Address is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Digital'">
                                <label>email<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input type="email" class="form-control" formControlName="email" style="border: 1px solid black" (blur)="setToOtherFields('degree',$event,i,'email')" />
                                  <div *ngIf="(degree.get('email').errors && (degree.get('email').dirty || degree.get('email').touched))"><span style="color:red; font-weight:bold;">Email address is required.</span></div>
                              </div>
                            </div>
                            <div class="row SUbtn">
                              <div class="col-md-2">
                                <button (click)="saveInstituteDetails('degree',i)" style="border: 1px solid black">Save</button>
                              </div>
                              <div class="col-md-2">
                                <button nbButton hero status="danger" (click)="deleteDetails(degrees.controls['degreeInstitute'].controls[i].controls.id.value,'Ins_details')">Delete</button></div>
                            </div>
                          </div>
                        </div>
                      </form>
    
                      <form [formGroup]="secondYears" class="InstituteDetails" *ngIf="InsecondYearss==true">
                        <div class="form-group" formArrayName="secondYearInstitute"
                          *ngFor="let secondYear of secondYears.get('secondYearInstitute')['controls']; let i = index;">
                          <div class="tab1" [formGroupName]="i">
                            <h5>Institute/ Agency/ Company</h5>
                            <h6>Enter {{i + 1}} Details</h6><span style="color:red; font-weight:bold;">Read the filled details carefully and save details by clicking on save</span>
                            <div class="row">
                              <div class="col-xl-3">
                                <label>Reference No<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input  type="text" nbInput formControlName="referenceNo"
                                  (blur)="setToOtherFields('secondYear',$event,i,'refNO')">
                                  <div *ngIf="(secondYear.get('referenceNo').errors && secondYear.get('referenceNo').errors.required)"  >
                                    <div *ngIf="(secondYear.get('referenceNo').errors && (secondYear.get('referenceNo').dirty || secondYear.get('referenceNo').touched))"><span style="color:red; font-weight:bold;">Reference number is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3">
                                <label>Name<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input   type="text" nbInput formControlName="name"
                                  (blur)="setToOtherFields('secondYear',$event,i,'instName')">
                                  <div *ngIf="(secondYear.get('name').errors && secondYear.get('name').errors.required)"  >
                                    <div *ngIf="(secondYear.get('name').errors && (secondYear.get('name').dirty || secondYear.get('name').touched))"><span style="color:red; font-weight:bold;">Name is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Physical'">
                                <label>Address<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <input   type="textarea" nbInput formControlName="address"
                                  (blur)="setToOtherFields('secondYear',$event,i,'address')">
                                  <div *ngIf="(secondYear.get('address').errors && secondYear.get('address').errors.required)"  >
                                    <div *ngIf="(secondYear.get('address').errors && (secondYear.get('address').dirty || secondYear.get('address').touched))"><span style="color:red; font-weight:bold;">Address is required.</span></div>
                                  </div>
                              </div>
                              <div class="col-xl-3" *ngIf="selectedDelivery == 'Digital'">
                                <label>email<span style="color:red; font-weight:bold">*</span></label>
                                <br />
                                <!-- <input type="text" nbInput formControlName="email"> -->
                                <input type="email" class="form-control" formControlName="email" (blur)="setToOtherFields('secondYear',$event,i,'email')" />
                                  <div *ngIf="(secondYear.get('email').errors && (secondYear.get('email').dirty || secondYear.get('email').touched))"><span style="color:red; font-weight:bold;">Email address is required.</span></div>
                              </div>
                            </div>
                            <div class="row SUbtn">
                              <div class="col-md-2">
                                <button (click)="saveInstituteDetails('secondYear',i)">Save</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-xl-3" style="text-align: center;">
                      <div class="row">
                        <div class="col-xl-2"></div>
                        <div class="col-xl-8" style="padding-top:100px;">
                          <p style="font-size: 150%"><b>Need Help?</b></p><br>
                          <img class="videoimg"  src="{{imageUrl}}/api/upload/profile_pic/PLAY.png" data-toggle="modal" width="100px;" height="150px;" data-target="#myModal" data-video-fullscreen=""  (click)="videoPopup(3)">
                          <br>
                          <b>कोणत्याही प्रश्नासाठी आम्हाला<a style="color:#40dc7e">{{helpEmailId}}</a>वर ईमेल करा किंवा {{helpMobNo}} वर संपर्क साधा</b>
                        </div>
                        <div class="col-md-2"></div>
                      </div>
                      
                    </div>
                  </div>
                  

                </nb-card-body>

                <nb-card-footer class="footer-btn">
                  <button (click)="prevStep();" nbButton>previous</button>
                  <button (click)="nextStep();" style="margin-left: 5%;" nbButton>next</button>
                </nb-card-footer>
              </nb-card>
            </nb-step>

            <nb-step [completed]="tabcheck4" label="Preview">
              <nb-card>

                <nb-card-body>
                  <div *ngIf="(language=='English') || (language == null || language == undefined ) ">
                  <div style="text-align: left; ">
                    <h5>Instructions (सूचना)</h5>
                    <ul>
                      <li style="color: black;"><b> कृपया पेमेंटसाठी पुढे जाण्यापूर्वी सर्व डेटा सत्यापित (verify) करा.</b></li>
                      <li style="color: black;"><b>तुम्हाला कोणताही डेटा (Edit) संपादित/काढायचा (Remove) असल्यास, कृपया संबंधित पायरीवर जा. पुन्हा पुढे जाण्यापूर्वी डेटा जतन (Save) करण्यास विसरू नका.</b></li>
                      <li style="color: black;"><b> प्रत्येक दस्तऐवजाचे पूर्वावलोकन (preview) करण्यासाठी त्यावर क्लिक करा. तुमच्याकडे पीडीएफ फाइल अपलोड केली असल्यास, दस्तऐवजाचे पूर्वावलोकन करण्यासाठी पीडीएफ चिन्हावर क्लिक करा. </b></li>
                    </ul>
                  </div>
                  </div>
                  <div *ngIf="language=='Gujarati' ">
                    <div style="text-align: left; ">
                      <h5>સૂચનાઓ</h5>
                      <ul>
                        <li style="color: red;"><b> કૃપા કરીને પેમેન્ટ માટે આગળ વધતા પહેલા તમામ ડેટાની વેરીફાઈ કરો.</b></li>
                        <li style="color: red;"><b> જો તમે કોઈપણ ડેટાને એડિટ / નિકાળવા માંગતા હો, તો કૃપા કરીને સંબંધિત પગલા પર જાઓ . ફેરફારો
                          કરો અને ફરીથી આગળ વધતા પહેલા ડેટાને સેવ કરવાનું ભૂલશો નહીં.</b></li>
                        <li style="color: red;"><b> દરેક ડોક્યુમેન્ટ્સ નું પ્રિવિયુ કરવા માટે તેના પર ક્લિક કરો. જો તમારી પાસે પીડીએફ ફાઇલ અપલોડ છે, તો
                          ડોક્યુમેન્ટ્સ નું પ્રિવિયુ કરવા માટે પીડીએફ આઇકોન પર ક્લિક કરો. </b></li>
                      </ul>
                    </div>
                    </div>
                  <div class="row">
                    <div class="col-md-2" style="text-align: center;margin-bottom: 3%;">
                      <img src="{{logo}}" style="height: 45px; width: 45px;">
                    </div>
                    <div class="col-md-10" style="text-align: center;">
                      <label style="font-size: x-large; font-family: initial;">SOLAPUR UNIVERSITY</label><br>
                      <label style="font-size: unset; font-family: initial;">Application Form for
                        Marksheet/Degree/Transcript Verification</label><br>
                      <div style="text-align: center;"> <label style="font-size: unset; font-family: initial;color:red">
                          <span *ngIf="verificationDetails?.marksheet == true">
                            Marksheet ({{verificationDetails?.noOfMarksheet}})
                          </span>
                          <span *ngIf="verificationDetails?.transcript == true"> + Transcript
                            ({{verificationDetails?.noOfTranscript}})</span>
                          <span *ngIf="verificationDetails?.degreeCertificate == true"> + Degree Certificate
                            ({{verificationDetails?.noOfDegree}})</span>
                          <span *ngIf="verificationDetails?.sealedCover == true"> + Sealed Cover
                            ({{verificationDetails?.noOfCopies}})</span>
                          
                        </label></div>
                    </div>
                  </div>
                  <nb-card>
                    <nb-card-header>
                      <span style="font-weight:'bold'; font-size:16px;">Personal Details</span>
                    </nb-card-header>
                    <nb-card-body>
                      <div class="row">
                        <div class="col-md-4">Student Name: &nbsp;{{personalDetails?.marksheetName}} </div>
                        <!-- <div class="col-md-4">{{personalDetails?.marksheetName}}</div> -->
                      </div><br>
                      <div class="row">
                        <div class="col-md-4">Email Address: &nbsp; {{personalDetails?.email}}</div>
                        <!-- <div class="col-md-4">{{personalDetails?.email}}</div> -->
                      </div><br>
                      <div class="row">
                        <div class="col-md-4">Mobile No: &nbsp; {{personalDetails?.mobile}}</div>
                        <!-- <div class="col-md-4">{{personalDetails?.mobile}}</div> -->
                      </div>
                      

                    </nb-card-body>
                  </nb-card>
                  <div class="col-md-12" *ngIf="marksheetDetails != ''">
                    <h4>Marksheet Verification Details</h4>
                    

                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Institute / Agency / Company Details</span></div>
                      </nb-card-header>
                      <nb-card-body>
                        <form [formGroup]="marksheets">
                          <div *ngFor="let marksheetInstitute of marksheetInstituteDetails let i= index">
                            <nb-card-body>
                              <div style="font-weight:bold;">Institute / Agency {{ i+1}} </div>
                              <div class="row">
                                <div class="col-md-4">Reference No  : &nbsp; {{marksheetInstitute?.referenceNo}}</div>
                                <!-- <div class="col-md-4">{{marksheetInstitute?.referenceNo}}</div> -->
                              </div><br>

                              <div class="row">
                                <div class="col-md-4">Name  : &nbsp; {{marksheetInstitute?.name}}</div>
                                <!-- <div class="col-md-4">{{marksheetInstitute?.name}}</div> -->
                              </div><br>
                              <div class="row" *ngIf="marksheetInstitute?.address != undefined || marksheetInstitute?.address != null">
                                <div class="col-md-4">Address  : &nbsp; {{marksheetInstitute?.address}}</div>
                                <!-- <div class="col-xl-4">{{marksheetInstitute?.address}}</div> -->
                              </div><br>
                              <div class="row" *ngIf="marksheetInstitute?.email != undefined || marksheetInstitute?.email != null">
                                <div class="col-md-4">Email  : &nbsp; {{marksheetInstitute?.email}}</div>
                                <!-- <div class="col-md-4">{{marksheetInstitute?.email}}</div> -->
                              </div>
                            </nb-card-body>
                          </div>
                        </form>
                      </nb-card-body>
                    </nb-card>

                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Educational Details</span></div>
                      </nb-card-header>
                      <nb-card-body>
                        <!-- <form [formGroup]="marksheets" *ngIf="marksheetss==true"> -->
                        <div *ngFor="let marksheet of marksheetDetails let i= index">

                          <div style="font-weight:bold;">Marksheet {{ i+1}} </div>
                          <div class="row">
                            <div class="col-xl-4">Degree / Course  : &nbsp; {{marksheet?.courseName}}</div>
                            <!-- <div class="col-xl-4">{{marksheet?.courseName}}</div> -->
                          </div>

                         <div class="row">
                            <div class="col-xl-4">Seat Number : &nbsp; {{marksheet?.seatNo}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.seatNo}}</div> -->
                          </div>
                          <div class="row">
                            <div class="col-xl-4">Month-Year  : &nbsp; {{marksheet?.passingMonthYear}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                          <div class="row" *ngIf="marksheet?.mbaCheck == true">
                            <div class="col-xl-4">Course Duration  : &nbsp; {{marksheet?.courseDuration}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                          <div class="row" *ngIf="marksheet?.mbaCheck == true">
                            <div class="col-xl-4">Elective Group  : &nbsp; {{marksheet?.majorSubject}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                          <div class="row" *ngIf="marksheet?.mbaCheck == true">
                            <div class="col-xl-4">Total Grade Points : &nbsp; {{marksheet?.totalGrade}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                          <div class="row" *ngIf="marksheet?.mbaCheck == true">
                            <div class="col-xl-4">Average Grade Points : &nbsp; {{marksheet?.avgGrade}} </div>
                            <!-- <div class="col-xl-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                          <br/>
                        </div>
                      </nb-card-body>

                      <!-- </form> -->
                    </nb-card>
                  </div>

                  <div class="col-md-12" *ngIf="transcriptDetails !=''">
                    <h4>Transcripts Verification Details</h4>
                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Institute / Agency / Company Details</span></div>
                      </nb-card-header>
                      <nb-card-body>
                        <form [formGroup]="transcripts">
                          <div *ngFor="let transcriptInstitute of transcriptInstituteDetails let i= index">
                            <nb-card-body>
                              <div style="font-weight:bold;">Institute / Agency / Company {{ i+1}} </div>
                              <div class="row">
                                <div class="col-xl-4">Reference No : &nbsp; {{transcriptInstitute?.referenceNo}} </div>
                                <!-- <div class="col-xl-4">{{transcriptInstitute?.referenceNo}}</div> -->
                              </div>

                              <div class="row">
                                <div class="col-xl-4">Name  : &nbsp; {{transcriptInstitute?.name}} </div>
                                <!-- <div class="col-xl-4">{{transcriptInstitute?.name}}</div> -->
                              </div>
                              <div class="row" *ngIf="transcriptInstitute?.address != undefined || transcriptInstitute?.address != null">
                                <div class="col-xl-4">Address  : &nbsp; {{transcriptInstitute?.address}}</div>
                                <!-- <div class="col-xl-4">{{transcriptInstitute?.address}}</div> -->
                              </div>
                              <div class="row" *ngIf="marksheetInstitute?.email != undefined || transcriptInstitute?.email != null">
                                <div class="col-xl-4">Email  : &nbsp; {{transcriptInstitute?.email}} </div>
                                <!-- <div class="col-xl-4">{{transcriptInstitute?.email}}</div> -->
                              </div>
                            </nb-card-body>
                          </div>
                        </form>
                      </nb-card-body>
                    </nb-card>

                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Educational Details</span></div>
                      </nb-card-header>

                      <nb-card-body>
                        <div *ngFor="let transcript of transcriptDetails let i= index">
                          <div style="font-weight:bold;">Transcript {{ i+1}} </div>
                          <div class="row">
                            <div class="col-xl-4">Degree / Course : &nbsp; {{transcript?.courseName}} </div>
                            <!-- <div class="col-xl-4">{{transcript?.courseName}}</div> -->
                          </div>
                          <div class="row">
                            <div class="col-xl-4">Seat Number : &nbsp; {{transcript?.seatNo}} </div>
                            <!-- <div class="col-xl-4">{{transcript?.seatNo}}</div> -->
                          </div>
                          <div class="row">
                            <div class="col-xl-4">Month-Year : &nbsp; {{transcript?.passingMonthYear}}</div>
                            <!-- <div class="col-xl-4">{{transcript?.passingMonthYear}}</div> -->
                          </div>
                        </div>
                      </nb-card-body>

                    </nb-card>
                  </div>

                  <div class="col-md-12" *ngIf="degreeDetails !=''">
                    <h4>Degree Verification Details</h4>
                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Institute / Agency / Company Details</span></div>
                      </nb-card-header>
                      <nb-card-body>
                        <form [formGroup]="degrees">
                          <div *ngFor="let degreeInstitute of degreeInstituteDetails let i= index">
                            <nb-card-body>
                              <div style="font-weight:bold;">Institute/Agency/Company {{ i+1}} </div>
                              <div class="row">
                                <div class="col-xl-4">Reference No : &nbsp; {{degreeInstitute?.referenceNo}} </div>
                                <!-- <div class="col-xl-4">{{degreeInstitute?.referenceNo}}</div> -->
                              </div>

                              <div class="row">
                                <div class="col-xl-4"> Name  : &nbsp; {{degreeInstitute?.name}} </div>
                                <!-- <div class="col-xl-4">{{degreeInstitute?.name}}</div> -->
                              </div>
                              <div class="row" *ngIf="degreeInstitute?.address != undefined || degreeInstitute?.address != null">
                                <div class="col-xl-4">Address  : &nbsp; {{degreeInstitute?.address}} </div>
                                <!-- <div class="col-xl-4">{{degreeInstitute?.address}}</div> -->
                              </div>
                              <div class="row" *ngIf="degreeInstitute?.email != undefined || degreeInstitute?.email != null">
                                <div class="col-xl-4">Email  : &nbsp; {{degreeInstitute?.email}} </div>
                                <!-- <div class="col-xl-4">{{degreeInstitute?.email}}</div> -->
                              </div>
                            </nb-card-body>
                          </div>
                        </form>
                      </nb-card-body>
                    </nb-card>

                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Educational Details</span></div>
                      </nb-card-header>

                      <nb-card-body>
                        <div *ngFor="let degree of degreeDetails let i= index">
                          <div style="font-weight:bold;">Marksheet {{ i+1}} </div><br>
                          <div class="row">
                            <div class="col-md-4">Degree / Course  : &nbsp; {{degree?.courseName}} </div>
                            <!-- <div class="col-md-4">{{marksheet?.courseName}}</div> -->
                          </div><br>

                         <div class="row">
                            <div class="col-md-4">Seat Number : &nbsp; {{degree?.seatNo}} </div>
                            <!-- <div class="col-md-4">{{marksheet?.seatNo}}</div> -->
                          </div><br>
                          <div class="row">
                            <div class="col-md-4">Month-Year  : &nbsp; {{degree?.passingMonthYear}} </div>
                            <!-- <div class="col-md-4">{{marksheet?.passingMonthYear}}</div> -->
                          </div>
                        </div>
                      </nb-card-body>

                    </nb-card>
                  </div>

                  <div class="col-md-12" *ngIf="secondYearDetails !=''">
                    <h4>Second Year Marksheet Verification Details</h4>
                   <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Institute / Agency / Company Details</span></div>
                      </nb-card-header>
                      <nb-card-body>
                        <form [formGroup]="secondYears">
                          <div *ngFor="let secondYearInstitute of secondYearInstituteDetails let i= index">
                            <nb-card-body>
                              <div style="font-weight:bold;">Institute / Agency / Company {{ i+1}} </div><br>
                              <div class="row">
                                <div class="col-md-4">Reference No: &nbsp; {{secondYearInstitute?.referenceNo}} </div> 
                                <!-- <div class="col-md-4">{{secondYearInstitute?.referenceNo}}</div> -->
                              </div><br>
                              <div class="row">
                                <div class="col-md-4">Name: &nbsp; {{secondYearInstitute?.name}} </div>
                                <!-- <div class="col-md-4">{{secondYearInstitute?.name}}</div> -->
                              </div><br>
                              <div class="row" *ngIf="secondYearInstitute?.address != undefined || secondYearInstitute?.address != null">
                                <div class="col-md-4">Address: &nbsp; {{secondYearInstitute?.address}} </div>
                                <!-- <div class="col-md-4">{{secondYearInstitute?.address}}</div> -->
                              </div><br>
                              <div class="row" *ngIf="secondYearInstitute?.email != undefined || secondYearInstitute?.email != null">
                                <div class="col-md-4">Email: &nbsp; {{secondYearInstitute?.email}} </div>
                                <!-- <div class="col-md-4">{{secondYearInstitute?.email}}</div> -->
                              </div>
                            </nb-card-body>
                          </div>
                        </form>
                      </nb-card-body>
                    </nb-card>

                    <nb-card>
                      <nb-card-header>
                        <div><span style="font-weight:'bold'; font-size:16px;">Educational Details</span></div>
                      </nb-card-header>

                      <nb-card-body >
                        <div *ngFor="let secondyear of secondYearDetails let i= index">
                          <div *ngIf="secondyear?.semester == 'Semester III' || secondyear?.semester == 'Second Year'">
                            <div class="row" >
                              <div class="col-md-4">CollegeName: &nbsp; {{secondyear?.collegeName}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.collegeName}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Course Name: &nbsp; {{secondyear?.courseName}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.courseName}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Enrollment Start: &nbsp; {{secondyear?.enrollmentStart}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.enrollmentStart}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Enrollment End: &nbsp; {{secondyear?.enrollmentEnd}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.enrollmentEnd}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Major Subjct: &nbsp; {{secondyear?.majorSubject}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.majorSubject}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Subsidary Subject: &nbsp; {{secondyear?.subsidarySubject}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.subsidarySubject}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Semester / Year: &nbsp; {{secondyear?.semester}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.semester}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">passing Month-Year: &nbsp; {{secondyear?.passingMonthYear}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.passingMonthYear}}</div> -->
                            </div><br>
                            <div class="row">
                              <div class="col-md-4">Result Class: &nbsp; {{secondyear?.result}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.result}}</div> -->
                            </div>
                            </div>
                            <div class="row" *ngIf="secondyear?.semester == 'Semester IV'">
                              <div class="col-md-4">Semester / Year: &nbsp; {{secondyear?.semester}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.semester}}</div> -->
                            </div><br>
                            <div class="row" *ngIf="secondyear?.semester == 'Semester IV'">
                              <div class="col-md-4">passing Month-Year: &nbsp; {{secondyear?.passingMonthYear}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.passingMonthYear}}</div> -->
                            </div><br>
                            <div class="row" *ngIf="secondyear?.semester == 'Semester IV'">
                              <div class="col-md-4">Result Class: &nbsp; {{secondyear?.result}} </div>
                              <!-- <div class="col-md-4">{{secondyear?.result}}</div> -->
                            </div>
                    </div>
                      </nb-card-body>

                    </nb-card>
                  </div>

                  <nb-card>
                    <nb-card-header>
                      <span style="font-weight:'bold'; font-size:16px;">Uploaded Documents</span>
                    </nb-card-header>
                    <nb-card-body>

                      <div *ngIf="verificationDetails?.marksheet == true">
                        <hr />
                        <div class="row">
                          <div class="col-md-4" style="font-weight: bold; font-size: 14px; margin-bottom: 3%;">Marksheet
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4" *ngFor="let marksheet of marksheetDetails" style="text-align: center;">
                          
                            <div  (click)="imagePopup(marksheet?.fileName,'edu_document')">
                              <div *ngIf=" marksheet.fileExtension  == 'pdf'">
                                <img src="{{ pdfImg }}" width="100px;" height="100px;">
                              </div>

                              <div *ngIf=" marksheet.fileExtension  != 'pdf'">
                                <img src="{{marksheet?.fileSrc}}" width="100px;" height="100px;">
                              </div>

                              <p>{{marksheet?.courseName}} {{ marksheet?.semester }}</p>
                            </div>
                          </div>

                        </div>

                      </div>

                      <div *ngIf="verificationDetails?.transcript == true">
                        <hr />
                        <div class="row">
                          <div class="col-md-4" style="font-weight: bold; font-size: 14px; margin-bottom: 3%;">
                            Transcripts</div>
                        </div>
                        <div class="row">
                          <div class="col-md-4" *ngFor="let transcript of transcriptDetails" style="text-align: center;">
                          
                            <div  (click)="imagePopup(transcript?.fileName,'edu_document')">
                              <!-- <img src="getExtension(transcript.fileExtension)"> -->
                              <div *ngIf=" transcript.fileExtension  == 'pdf'">
                                <img src="{{ pdfImg }}" width="100px;" height="100px;">
                              </div>
                              <div *ngIf=" transcript.fileExtension  != 'pdf'">
                                <img src="{{transcript?.fileSrc}}" width="100px;" height="100px;">
                              </div>
                              <p>{{marksheet?.courseName}}</p>
                              <!-- <div *ngIf=" transcript.fileExtension == 'pdf' "> <img src="../../../assets/images/pdf1.png"  width="100px;" height="100px;"> </div> -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="verificationDetails?.degreeCertificate == true">
                        <hr />
                        <div class="row">
                          <div class="col-md-4" style="font-weight: bold; font-size: 14px; margin-bottom: 3%;">Degree
                            Certificates</div>
                        </div>
                        <div class="row">
                          <div class="col-md-4" *ngFor="let degree of degreeDetails" style="text-align: center;">
                          
                            <div  (click)="imagePopup(degree?.fileName,'edu_document')">
                              <div *ngIf=" degree.fileExtension  == 'pdf'">
                                <img src="{{ pdfImg }}" width="100px;" height="100px;">
                              </div>
                              <div *ngIf=" degree.fileExtension  != 'pdf'">
                                <img src="{{degree?.fileSrc}}" width="100px;" height="100px;">
                              </div>
                              <p>{{marksheet?.courseName}}</p>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div *ngIf="verificationDetails?.secondYear == true">
                        <hr />
                        <div class="row">
                          <div class="col-md-4" style="font-weight: bold; font-size: 14px; margin-bottom: 3%;">Second
                            Year Verification</div>
                        </div>
                        <div class="row">
                        <div class="col-md-4" *ngFor="let secondyear of secondYearDetails" style="text-align: center;">
                          
                            <div  (click)="imagePopup(secondyear?.fileName,'edu_document')">
                              <div *ngIf=" secondyear.fileExtension  == 'pdf'">
                                <img src="{{ pdfImg }}" width="100px;" height="100px;">
                              </div>
                              <div *ngIf=" secondyear.fileExtension  != 'pdf'">
                                <img src="{{secondyear?.fileSrc}}" width="100px;" height="100px;">
                              </div>
                              <p>{{marksheet?.courseName}}</p>
                            </div>
                          </div>
                          <br/>
                        </div>
                      </div>
                    </nb-card-body>
                  </nb-card>
                </nb-card-body>
                <nb-card-footer>
                  <div class="row">
                    <div class="col-md-6" style="text-align: center;margin-bottom: 2%;">
                      <button (click)="prevStep();" style="margin-right: 5%;" nbButton>previous</button>
                    </div><br>
                    <div class="col-md-6" style="text-align: center;">
                      <button (click)="nextStep();" nbButton>Proceed For Payment</button>
                    </div>
                  </div>
                </nb-card-footer>
              </nb-card>
            </nb-step>

          </nb-stepper>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-dialog [(visible)]="displayvideo1" [modal]="true" [responsive]="true" [style]="{width: '350px', minWidth: '200px'}">
  <nb-card  style="width: 350px;min-width: 200px;">
    <nb-card-body  id="cardbody1">
      <video id="video1" src="{{imageUrl}}/api/upload/videos/solverification.mp4" controls style="width: 300px;min-width: 200px;min-height: 200px;"></video>
    </nb-card-body>
  </nb-card>
</p-dialog>

<p-dialog [(visible)]="displayvideo2" [modal]="true" [responsive]="true" [style]="{width: '350px', minWidth: '200px'}">
  <nb-card  style="width: 350px;min-width: 200px;">
    <nb-card-body  id="cardbody2">
      <video id="video2" src="{{imageUrl}}/api/upload/videos/solverification.mp4" controls style="width: 300px;min-width: 200px;min-height: 200px;"></video>
    </nb-card-body>
  </nb-card>
</p-dialog>

<p-dialog [(visible)]="displayvideo3" [modal]="true" [responsive]="true" [style]="{width: '350px', minWidth: '200px'}">
  <nb-card  style="width: 350px;min-width: 200px;">
    <nb-card-body  id="cardbody3">
      <video id="video3" src="{{imageUrl}}/api/upload/videos/solverification.mp4" controls style="width: 300px;min-width: 200px;min-height: 200px;"></video>
    </nb-card-body>
  </nb-card>
</p-dialog>